import { useSelector } from "react-redux";

import {
  translations,
  surveyTranslations,
} from "../utils/translations";

export const useTranslation = () => {
  const language = useSelector(
    (state) => state.language.current
  );

  const t = (key) => {
    if (!key) return "";

    let value = translations[language];

    const keys = key.split(".");

    for (const k of keys) {
      value = value?.[k];
    }

    return value || "key";
  };

  const tq = (surveyType, questionId, fallback) => {
    return (
      surveyTranslations?.[language]?.[surveyType]?.[questionId] ||
      fallback
    );
  };

  const tqh = (surveyType, key, fallback) => {
    return (
      surveyTranslations?.[language]?.[surveyType]?.[key] ||
      fallback
    );
  };

  const titleTranslate = (surveyType, sectionId, fallback) => {
    return (
      surveyTranslations?.[language]?.[surveyType]?.[`SECTION_${sectionId}`] ||
      fallback
    );
  };

  const tOption = (label) => {
    if (!label) return label;

  const key = label
    .trim()
    .toLowerCase()
    .replace(/[^\w\s]/g, "") // remove punctuation
    .replace(/\s+/g, "_");

    return (
      translations?.[language]?.common?.[key] ||
      label
    );
  };

  return {
    t,
    tq,
    tqh,
    titleTranslate,
    tOption,
    language,
  };
};